export const normalizeCommentRealtimeId = (value) => {
  if (value === undefined || value === null) return '';
  if (typeof value === 'object' && value._id && value._id !== value) {
    return normalizeCommentRealtimeId(value._id);
  }
  return String(value);
};

export const removeCommentById = (comments = [], commentId) => {
  if (!Array.isArray(comments)) return [];
  const targetId = normalizeCommentRealtimeId(commentId);
  if (!targetId) return comments;
  return comments.filter(
    (comment) => normalizeCommentRealtimeId(comment?._id) !== targetId,
  );
};

export const resolveCommentDeleteList = (previousComments = [], payload = {}) =>
  Array.isArray(payload.comments)
    ? payload.comments
    : removeCommentById(previousComments, payload.commentId);

export const applyCommentDeleteToItems = (
  items = [],
  payload = {},
  parentKey,
) => {
  const parentId = normalizeCommentRealtimeId(payload[parentKey]);
  if (!parentId || !Array.isArray(items)) return items;

  return items.map((item) => {
    if (normalizeCommentRealtimeId(item?._id) !== parentId) return item;
    return {
      ...item,
      comments: resolveCommentDeleteList(item?.comments || [], payload),
    };
  });
};
